import React from 'react';

import { H3 } from '@repo/ui-kit/components/core/Typography';

import TextBlock from 'strapi/component/shared/TextBlock/TextBlock';
import { FlexRow } from 'styles/layouts';

import { TextContainer } from './styles';
import { TextSectionProps } from './types';

const maxItemPerRow = 4;

export const TextSectionRow: React.FC<TextSectionProps> = ({
  textSections,
}) => {
  const lastRowIndex = Math.floor((textSections.length - 1) / maxItemPerRow);

  const itemsInLastRow = textSections.length % maxItemPerRow || maxItemPerRow;

  return (
    <FlexRow flexWrap="wrap">
      {textSections.map((item, index) => {
        const rowCount = Math.floor(index / maxItemPerRow);
        const totalItemsThisRow =
          rowCount === lastRowIndex ? itemsInLastRow : maxItemPerRow;

        return (
          <TextContainer key={index} itemCount={totalItemsThisRow}>
            <H3 bold>{item.title}</H3>
            <TextBlock key={index} paragraphType="p2" text={item.text} />
          </TextContainer>
        );
      })}
    </FlexRow>
  );
};
